namespace GeniuzPOS.Purchase {
    export class PoPurRequestDtAppColumns {
        static columnsKey = 'Purchase.PoPurRequestDtApp';
    }
}
